import {
  WinnerSchema,
  LotteryDrawSchema,
  LotterySchema,
  RetailUnitSchema,
} from '@lotta/shared/types-lottery-schemas';
import type { Static } from '@sinclair/typebox';
import { Type } from '@sinclair/typebox';

export type GetWinnersParams = Static<typeof GetWinnersParamsSchema>;
export const GetWinnersParamsSchema = Type.Object(
  {
    retailUnit: RetailUnitSchema.properties.id,
    lotteryId: LotterySchema.properties.id,
    lotteryDrawId: LotteryDrawSchema.properties.id,
  },
  { additionalProperties: false, $id: 'GetWinnersParamsSchema' }
);

export type GetWinnersResponse = Static<typeof GetWinnersResponseSchema>;
export const GetWinnersResponseSchema = Type.Object(
  {
    winners: Type.Array(WinnerSchema),
  },
  { additionalProperties: false, $id: 'GetWinnersResponseSchema' }
);
